/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-15 17:19:16
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-03-15 17:31:09
 * @Description: file content
 */

export default JSON.parse(process.env.REACT_APP_DOMAINS || '');
